import { isFrozenDispatcherStatusCode } from "./dispatcherFreezeStatus.js";

export const PROTECTION_VARIANT_STANDARD = "standard";
export const PROTECTION_VARIANT_REORDERED = "reordered";

export const REORDERED_PROTECTION_TONE = "protection-reordered";
export const REORDERED_PROTECTION_ACCENT_COLOR = "rgb(109, 40, 217)";

function normalizeProtectionVariant(value) {
  return typeof value === "string" ? value.trim().toLowerCase() : "";
}

export function resolveProtectionVariant(manualStatus = null) {
  if (!manualStatus || typeof manualStatus !== "object") {
    return null;
  }

  if (manualStatus.code === "protected") {
    return PROTECTION_VARIANT_STANDARD;
  }

  if (manualStatus.code === "reordered") {
    return PROTECTION_VARIANT_REORDERED;
  }

  if (manualStatus.code === "reassigned") {
    return null;
  }

  const variant = normalizeProtectionVariant(manualStatus.protectionVariant);
  if (variant === PROTECTION_VARIANT_STANDARD || variant === PROTECTION_VARIANT_REORDERED) {
    return variant;
  }

  return null;
}

export function getProtectionAccentColor(manualStatus = null) {
  return resolveProtectionVariant(manualStatus) === PROTECTION_VARIANT_REORDERED
    ? REORDERED_PROTECTION_ACCENT_COLOR
    : "var(--color-accent)";
}

export function buildVisibleProtectionStatus(
  manualStatus = null,
  { hasReleaseButton = false, dispatcherStatusCode = "" } = {},
) {
  const variant = resolveProtectionVariant(manualStatus);
  if (!variant) {
    return null;
  }

  if (manualStatus?.code === "protected") {
    if (isFrozenDispatcherStatusCode(dispatcherStatusCode)) {
      return null;
    }
    return {
      ...manualStatus,
      protectionVariant: PROTECTION_VARIANT_STANDARD,
    };
  }

  if (manualStatus?.code === "reordered" && variant === PROTECTION_VARIANT_REORDERED && hasReleaseButton) {
    return {
      code: "protected",
      description: "Commande protégée par réordonnancement. Libérez-la au besoin.",
      icon: "shield",
      label: "Protégée",
      protectionVariant: PROTECTION_VARIANT_REORDERED,
      tone: "success",
    };
  }

  return null;
}

export function buildProtectionStatusMarker({
  blocked = false,
  blockingReason = "",
  manualAction = "",
  variant = PROTECTION_VARIANT_STANDARD,
} = {}) {
  if (blocked) {
    return {
      category: "protected",
      description: blockingReason || "Étape bloquée par une contrainte métier active.",
      icon: "alert",
      key: "blocked",
      label: "Bloquée",
      tone: "warning",
    };
  }

  if (variant === PROTECTION_VARIANT_REORDERED) {
    const description = manualAction === "reassigned"
      ? "Protégée par réaffectation manuelle — libérez-la au besoin."
      : manualAction === "reordered"
        ? "Protégée par réordonnancement — libérez-la au besoin."
        : "Protégée par intervention manuelle — libérez-la au besoin.";
    return {
      category: "protected",
      description,
      icon: "shield",
      key: "protected-reordered",
      label: "Protégée",
      tone: REORDERED_PROTECTION_TONE,
    };
  }

  return {
    category: "protected",
    description: "Commande protégée. Le bouton Optimiser ne la rebougera pas tant que cette protection reste active.",
    icon: "shield",
    key: "protected",
    label: "Protégée",
    tone: "success",
  };
}
